/* ************************************************************
src/layouts/AppLayout.jsx
레이아웃 컴포넌트 파일.
Header 컴포넌트 포함하고, Outlet 컴포넌트 사용해 자식 라우트 렌더링
* Framer Motion 라이브러리를 사용하면, 페이지가 바뀔 때마다 전환 애니메이션 추가
- nitial : 애니메이션 시작 상태, animate : 애니메이션 종료 상태
- transition : 애니메이션의 타입(type), 지속 시간(duration), 반복 횟수(repeat) 
**************************************************************/

import { motion, AnimatePresence } from "framer-motion";
import { useLocation, useOutlet, ScrollRestoration } from "react-router-dom";

export default function DefaultLayout() {
  const location = useLocation();
  const outlet = useOutlet();

  return (
    <>
      <AnimatePresence>
        <motion.div
          key={location.pathname}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0, position: "absolute" }}
          transition={{ duration: 0.3 }}
        >
          {outlet}
        </motion.div>
      </AnimatePresence>
      <ScrollRestoration />
    </>
  );
}
